
      function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUpdateContactAndAccountDetailsIconOk = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "icons / ok Done",
  xmlns: "http://www.w3.org/2000/svg",
  width: 92,
  height: 92,
  viewBox: "0 0 92 92"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "icons / ok Done"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Combined Shape",
  d: "M46.057 92A46.056 46.056 0 0 1 0 46 46 46 0 0 1 46 0a3 3 0 0 1 0 6 40 40 0 1 0 .065 80 37.888 37.888 0 0 0 9.18-1.106A39.887 39.887 0 0 0 86 46.058a3 3 0 1 1 6 0 45.879 45.879 0 0 1-35.35 44.67A43.82 43.82 0 0 1 46.178 92zm-6.969-31.745-.144-.136-12.067-12.088a3 3 0 0 1 4.1-4.374l.144.135 9.943 9.961L76.877 17.88a3 3 0 0 1 4.381 4.1l-.135.144-37.933 38a3 3 0 0 1-4.1.136z",
  style: {
    fill: "var(--theme-primary, #810ea9)"
  }
})));

      const __svgRaw = "<svg data-name=\"icons / ok Done\" xmlns=\"http://www.w3.org/2000/svg\" width=\"92\" height=\"92\" viewBox=\"0 0 92 92\">\r\n    <g data-name=\"icons / ok Done\">\r\n        <path data-name=\"Combined Shape\" d=\"M46.057 92A46.056 46.056 0 0 1 0 46 46 46 0 0 1 46 0a3 3 0 0 1 0 6 40 40 0 1 0 .065 80 37.888 37.888 0 0 0 9.18-1.106A39.887 39.887 0 0 0 86 46.058a3 3 0 1 1 6 0 45.879 45.879 0 0 1-35.35 44.67A43.82 43.82 0 0 1 46.178 92zm-6.969-31.745-.144-.136-12.067-12.088a3 3 0 0 1 4.1-4.374l.144.135 9.943 9.961L76.877 17.88a3 3 0 0 1 4.381 4.1l-.135.144-37.933 38a3 3 0 0 1-4.1.136z\" style=\"fill:var(--theme-primary, #810ea9)\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/update_contact_and_account_details_icon_ok.8c59e3f9974d72654ecd9e9f517f27bb.svg"),
        {
          React: SvgUpdateContactAndAccountDetailsIconOk,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      